// © Microsoft Corporation. All rights reserved.

import { ElementStyles, css } from "@microsoft/fast-element";
import { neutralForegroundRestBehavior, neutralOutlineRestBehavior } from "@fluentui/web-components";

export const FeedNavigationStyles: ElementStyles = css`
    .settings-link {
        border: 1px solid ${neutralOutlineRestBehavior.var};
        border-radius: 2px;
        padding: 0;
        margin: 0 0 0 15px;
        font-size: var(--type-ramp-base-font-size);
        line-height: var(--type-ramp-base-line-height);
        box-sizing: border-box; 
        cursor: pointer;
        color: ${neutralForegroundRestBehavior.var};
        fill: ${neutralForegroundRestBehavior.var};
    }

    .settings-link svg {
        width: 14px;
        height: 14px;
        padding: 0;
        color: ${neutralForegroundRestBehavior.var};
        fill: ${neutralForegroundRestBehavior.var};
    }
    
`.withBehaviors(
        neutralOutlineRestBehavior,
        neutralForegroundRestBehavior
    );
